/**
 * Collection Image Carousel Section — standalone JS
 * Extracted from product-detail.js section7 logic
 * Dependencies: Swiper (loaded globally via theme.liquid)
 */
document.addEventListener('DOMContentLoaded', function () {

    var swiperElement = document.querySelector('.collect-image-carousel-swiper');

    if (!swiperElement) {
        return; /* section not present on this page */
    }

    /* ----------------------------------------------------------------
     * Swiper initialisation
     * ---------------------------------------------------------------- */
    var swiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 12,
        loop: true,
        loopedSlides: 3,
        initialSlide: 1,
        speed: 600,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '.collect-image-carousel-button-next',
            prevEl: '.collect-image-carousel-button-prev'
        },
        breakpoints: {
            768: {
                spaceBetween: 28
            }
        }
    });

    /* ----------------------------------------------------------------
     * Shopify section-load re-initialisation
     * ---------------------------------------------------------------- */
    document.addEventListener('shopify:section:load', function (event) {
        var incomingEl = event.target.querySelector('.collect-image-carousel-swiper');

        if (!incomingEl || incomingEl.dataset.init === 'true') {
            return;
        }

        incomingEl.dataset.init = 'true';

        new Swiper(incomingEl, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 12,
            loop: true,
            loopedSlides: 3,
            initialSlide: 1,
            speed: 600,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: incomingEl.querySelector('.collect-image-carousel-button-next'),
                prevEl: incomingEl.querySelector('.collect-image-carousel-button-prev')
            },
            breakpoints: {
                768: {
                    spaceBetween: 28
                }
            }
        });
    });

});
